import LocalizedStrings from 'react-localization';
import {Link} from "@material-ui/core";
import * as React from "react";

export const t = new LocalizedStrings({
	en:{
		Users: "Users",
		User: "User",
		CreateNewUser: "Create new user",
		FirstName: "First Name",
		LastName: "Last Name",
		Actions: "Actions",
		Of: "of",
		Filter: "Filter",
		NoRecordsToDisplay: "No records to display",
		RowsSelected: "row(s) selected",
		Customer: "Customer",
		Customers: "Customers",
		CustomersList: "Customers list",
		NewCustomer: "New customer",
		AddCustomer: "Add customer",
		CreateNewCustomer: "Create new customer",
		Name: "Name",
		Email: "Email",
		VatId: "VAT id",
		CompanyId: "Legal id",
		InternalId: "Internal id",
		Address: "Address",
		Business: "Business",
		Price: "Price",
		PriceUnit: "Price unit",
		Date: "Date",
		Phone: "Phone",
		Title: "Title",
		Number: "Number",
		Description: "Description",
		Representative : "Representative",
		WebAddress: "Web address",
		Warning: "Warning",
		UserDataNotValid: "User data is not valid",
		ConfirmationMessage: "Are you sure you want to delete this?",
		SaveUser: "Save user to be able to add contacts",
		Contract: "Contract",
		Contracts: "Contracts",
		NewContract: "Contract new",
		CreateNewContract: "Create new contract",
		Save: "Save",
		ContractDataNotValid: "Contract data is not valid",
		SaveItem: "Save item to be able to upload documents",
		Invoice: "Invoice",
		Invoices: "Invoices",
		NewInvoice: "Invoice new",
		CreateNewInvoice: "Create new invoice",
		AddInvoice: "Add invoice",
		InvoiceList: "Invoices list",
		InvoiceDate: "Invoice paymentDate",
		SupplyDate: "Supply paymentDate",
		DueDate:"Due paymentDate",
		InvoiceDataNotValid : "Invoice data is not valid",
		Service: "Service",
		Services: "Services",
		CreateNewCateogry: "Create new category",
		NewService: "Service new",
		ServiceDataNotValid: "Service data is not valid",
		Category: "Category",
		Search: "Search",
		Rows: "rows",
		FirstPage: "First Page",
		PreviousPage: "Previous Page",
		NextPage: "Next Page",
		LastPage: "Last Page",
		Payment: "Payment",
		Payments: "Payments",
		PaymentDataNotValid: "Payment data is not valid",
		NewPayment: "Payment new",
		CreateNewPayment: "Create new payment",
		AddPayment: "Add payment",
		PaymentList: "Payments list",
		Categories: "Categories",
		NewCategory: "Category new",
		CreateNewCategory: "Create new category",
		Saldo: "Saldo",
		Finances: "Finances",
		Reports: "Reports",
		Menu1Title: "Business data",
		Menu2Title: "Users & Settings",
		Contacts: "Contacts",
		CreateNewContact: "Create new contact",
		RemoveAllSelectedItems: "Remove all selected items",
		CopySelectedItem: "Copy selected item",
		OpenSelectedItem: "Open selected item",
		CreateNewService: "Create new service",
		DragAndDropFiles: "Drag 'n' drop some files here, or click to select files",
		Password: "Password",
		DeleteConfirmation: "Delete confirmation",
		DeleteItemConfirmationMessage: "Are you sure you want to delete item?",
		AreYouSureYouWantToDelete: "Are you sure you want to delete",
		Items: "items",
		Cancel: "Cancel",
		Delete: "Delete",
		UnitAmount: "amount",
		PricePerUnit: "price per unit",
		UnitName: "unit name",
		Vat: "Vat",
		PriceAmount: "Price",
		PaymentDate: "Payment paymentDate",
		Role: "Role",
		Roles: "Roles",
		CreateNewRole: "Create new role",
		NewRole: "New role",
		GrantedRoles: "Granted roles",
		Alias: "Alias",
		Permissions: "Permissions",
		DocumentPermissions: "Document permissions",
		GrantedPermissions: "Granted permissions",
		DocumentGrantedPermissions: "Granted document permissions",
		UnauthorizedPermissions: "Unauthorized permissions",
		UnauthorizedDocumentPermissions: "Unauthorized document permissions",
		PerHour: "Per hour",
		PerDay: "Per day",
		PerMonth: "Per month",
		PerYear: "Per year",
		PerPiece: "Per piece",
		RequiredField: "Required field",
		RequiredFields: "Required fields",
		InvalidEmailAddress: "Invalid E-mail address",
		OnlyNumbersAllowed: "Only numbers allowed",
		InvalidPassword: "Invalid password",
		InvalidPhoneNumber: "Invalid phone number",
		VatIdLengthWarning: "Vat id must be 9 digit number",
		CompanyIdLengthWarning: "Company id must be 8 digit number",
		PersonalIdLengthWarning: "Personal id must be 13 digit number",
		PersonalIdDateWarning: "Personal id wrong date",
		PersonalIdDayWarning: "Personal id day must be 0-30/31, february 28/29",
		PersonalIdMonthWarning: "Personal id month must be 01-12",
		PersonalIdYearWarning: "Personal id year must be 1900-currentYear",
		PersonalIdWrongWarning: "Wrong personal id",
		All: "All",
		ForgotPassword: "Forgot password?",
		BackToLogin: "Back to login",
		ResetPasswordLinkMessage: "Reset password link was sent to your email address. Please check your inbox or spam folder.",
		Success: "Success",
		WrongEmailOrPassword: "Wrong email or password",
		NonExistentEmail: "User with this email address doesn't exists",
		PleaseEnterYourEmail: "Please enter your email",
		EnterNewPassword: "Enter new password",
		InvalidToken: "Invalid token",
		NotMatchingPasswords: "Passwords doesn't match",
		ResetPasswordMessage: "Your password has been successfully changed",
		ResetPasswordTokenExpiredMessage: "Reset password token does not exist or has expired.",
		TryResettingPasswordAgainMessage: "Please got to \"forgot password\" page and try again.",
		Send: "Send",
		Change: "Change",
		CustomerFinancesPrice: "Price",
		CustomerFinancesInvoiceNumber: "Invoice number",
		CustomerFinancesInvoiceDate: "Date (invoice issued / payment)",
		Type: "Type",
		CompanyStructure: "Structure",
		Department: "Department",
		DepartmentList: "Department list",
		NewDepartment: "Add department",
		ParentDepartment: "Parent department",
		CreateNewDepartment: "Create new department",
		Position: "Position",
		PositionList: "Position list",
		NewPosition: "Add position",
		CreateNewPosition: "Create new position",
		Notification: "Notification",
		Notifications: "Notifications",
		NotificationList: "Notification list",
		NewNotification: "Add notification",
		CreateNewNotification: "Create new notification",
		InvoicesPayments: "Invoices payments",
		ServicesReport: "Services report",
		Documents: "Documents",
		DocumentsSearch: "Documents search",
		DocumentsView: "Documents view",
		DocumentsIndexing: "Indexing",
		NewDocument: "New document",
		Settings: "Settings",
		Seen: "Seen",
		Employee: "Employee",
		EmployeesList: "EmployeesList",
		NewEmployee: "Add employee",
		CreateNewEmployee: "Create new employee",
		PersonalId: "Personal id",
		InsuranceId: "Insurance id",
		EducationLevel: "Education level",
		ContractType: "Contract type",
		UserId: "Connected with user",
		BirthDate: "Birth date",
		ContractEndDate: "Contract end date"
	},
	rs: {
		Users: "Korisnici",
		User: "Korisnik",
		CreateNewUser: "Kreirajte novog korisnika",
		FirstName: "Ime",
		LastName: "Prezime",
		Actions: "Akcije",
		Of: "od",
		Filter: "Filter",
		NoRecordsToDisplay: "Nema rezultata pretrage",
		RowsSelected: "red(a/ova) je izabrano",
		Customer: "Klijent",
		Customers: "Klijenti",
		NewCustomer: "Klijent",
		AddCustomer: "Dodaj klijenta",
		CustomersList: "Lista klijenata",
		CreateNewCustomer: "Kreiraj novog klijenta",
		Name: "Ime",
		Email: "Email",
		VatId: "PIB",
		CompanyId: "Matični broj",
		InternalId: "Interna šifra",
		Address: "Adresa",
		Business: "Delatnost",
		Price: "Cena",
		PriceUnit: "Jedinica plaćanja",
		Date: "Datum",
		Phone: "Telefon",
		Title: "Naziv",
		Number: "Broj",
		Description: "Opis",
		Representative : "Kontakt osoba",
		WebAddress: "Web stranica",
		Warning: "Upozorenje",
		UserDataNotValid: "Korisnički podaci nisu ispravni",
		ConfirmationMessage: "Da li ste sigurni da želite da obrišete objekat?",
		SaveUser: "Sačuvajte korisnika kako biste mogli da dodate kontakt",
		Contract: "Ugovor",
		Contracts: "Ugovori",
		NewContract: "Novi ugovor",
		CreateNewContract: "Kreirajte novi ugovor",
		AddContract: "Dodaj ugovor",
		ContractsList: "Lista ugovora",
		Save: "Sačuvaj",
		ContractDataNotValid: "Podaci o ugovoru nisu ispravni",
		SaveItem: "Sačuvajte objekat kako biste mogli da otpremite dokumenta",
		Invoice: "Faktura",
		Invoices: "Fakture",
		NewInvoice: "Nova faktura",
		CreateNewInvoice: "Kreirajte novu fakturu",
		AddInvoice: "Dodaj fakturu",
		InvoiceList: "Lista faktura",
		InvoiceDate: "Datum izdavanja",
		SupplyDate: "Datum prometa",
		DueDate: "Datum valute",
		InvoiceDataNotValid : "Podaci o fakturama nisu ispravni",
		Service: "Usluga",
		Services: "Usluge",
		CreateNewCateogry: "Kreirajte novu kategoriju",
		AddService: "Dodaj uslugu",
		ServicesList: "Lista usluga",
		NewService: "Novi servis",
		ServiceDataNotValid: "Podaci o servisu nisu ispravni",
		Category: "Kategorija",
		Search: "Pretraga",
		Rows: "redova",
		FirstPage: "Prva strana",
		PreviousPage: "Prethodna strana",
		NextPage: "Sledeća strana",
		LastPage: "Poslednja strana",
		Payment: "Plaćanje",
		Payments: "Plaćanja",
		PaymentDataNotValid: "Podaci o plaćanju nisu ispravni",
		NewPayment: "Novo plaćanje",
		CreateNewPayment: "Kreirajte novo plaćanje",
		AddPayment: "Dodaj uplatu",
		PaymentList: "Lista uplata",
		Categories: "Kategorije",
		NewCategory: "Nova kategorija",
		CreateNewCategory: "Kreirajtte novu kategoriju",
		AddCategory: "Dodaj kategoriju",
		CategoriesList: "Lista kategorija",
		Saldo: "Saldo",
		Finances: "Finansije",
		Reports: "Izveštaji",
		Menu1Title: "Poslovni podaci",
		Menu2Title: "Korisnici i podešavanja",
		Contacts: "Kontakti",
		CreateNewContact: "Dodaj novi kontakt",
		RemoveAllSelectedItems: "Obriši izabrane stavke",
		CopySelectedItem: "Kopiraj izabranu stavku",
		OpenSelectedItem: "Otvori izabranu stavku",
		CreateNewService: "Kreirajte novu uslugu",
		DragAndDropFiles: "Prevucite fajlove ili kliknete",
		Password: "Lozinka",
		DeleteConfirmation: "Potvrda za brisanje",
		DeleteItemConfirmationMessage: "Da li ste sigurni da želite da obrišete stavku?",
		AreYouSureYouWantToDelete: "Da li ste sigurni da želite da obrišete",
		Items: "stavke",
		Cancel: "Otkaži",
		Delete: "Obriši",
		UnitAmount: "Broj jedinica",
		PricePerUnit: "Cena po jedinici",
		UnitName: "Jedinica mere",
		Vat: "PDV",
		PriceAmount: "Iznos",
		PaymentDate: "Datum plaćanja",
		Role: "Uloga",
		Roles: "Uloge",
		CreateNewRole: "Dodaj novu ulogu",
		NewRole: "Dodaj ulogu",
		GrantedRoles: "Dodeljene uloge",
		Alias: "Alias",
		Permissions: "Dozvole",
		DocumentPermissions: "Dozvole za rad sa dokumentima",
		GrantedPermissions: "Odobrene dozvole",
		DocumentGrantedPermissions: "Odobrene dozvole nad dokumentima",
		UnauthorizedPermissions: "Neodobrene dozvole",
		UnauthorizedDocumentPermissions: "Neodobrene dozvole nad dokumentima",
		PerHour: "Po satu",
		PerDay: "Po danu",
		PerMonth: "Mesečno",
		PerYear: "Godišnje",
		PerPiece: "Po usluzi",
		RequiredField: "Obavezno polje",
		RequiredFields: "Obavezna polja",
		InvalidEmailAddress: "Neispravna E-mail adresa",
		OnlyNumbersAllowed: "Samo brojevi dozvoljeni",
		InvalidPassword: "Neispravna lozinka",
		InvalidPhoneNumber: "Neispravan broj telefona",
		VatIdLengthWarning: "PIB mora da sadrži 9 cifara",
		CompanyIdLengthWarning: "Matični broj mora da sadrži 8 cifara",
		PersonalIdLengthWarning: "JMBG mora sadžati 13 cifara",
		PersonalIdDateWarning: "Neispravan datum u JMBG",
		PersonalIdDayWarning: "Prva i druga cifra JMBG-a moraju biti u intervalu 01-30/31 (februar 01-28/29)",
		PersonalIdMonthWarning: "Treća i četvrta cifra JMBG-a moraju biti u intervalu 01-12",
		PersonalIdYearWarning: "Peta, šesta i sedma cifra moraju označavati tri poslednje cifre godine u intervalu 1900-tekuća_godina",
		PersonalIdWrongWarning: "Neispravan JMBG",
		All: "Svi",
		ForgotPassword: "Zaboravili ste lozinku?",
		BackToLogin: "Nazad na login",
		ResetPasswordLinkMessage: "Link za resetovanje lozinke je poslat na vašu email adresu. Proverite Vaš inbox ili spam folder.",
		Success: "Uspeh",
		WrongEmailOrPassword: "Pogrešan email ili lozinka",
		NonExistentEmail: "Korisnik sa ovom email adresom ne postoji",
		PleaseEnterYourEmail: "Unesite svoju email adresu",
		EnterNewPassword: "Unesite novu lozinku",
		InvalidToken: "Neispravan token",
		NotMatchingPasswords: "Lozinke nisu iste",
		ResetPasswordMessage: "Vaša lozinka je uspešno promenjena",
		ResetPasswordTokenExpiredMessage: "Token za resetovanje lozinke ne postoji ili je istekao.",
		TryResettingPasswordAgainMessage: "Pokušajte ponovo u delu \"zaboravljena lozinka\" da kreirate novi link za promenu lozinke.",
		Send: "Pošalji",
		Change: "Promeni",
		CustomerFinancesPrice: "Cena / Iznos",
		CustomerFinancesInvoiceNumber: "Broj fakture",
		CustomerFinancesInvoiceDate: "Datum (izdavanja fakture / uplate)",
		Type: "Tip",
		CompanyStructure: "Struktura",
		Department: "Sektor",
		DepartmentList: "Lista sektora",
		NewDepartment: "Dodaj sektor",
		CreateNewDepartment: "Dodaj nov sektor",
		ParentDepartment: "Nadređeni sektor",
		Position: "Pozicija",
		PositionList: "Lista pozicija",
		NewPosition: "Dodaj poziciju",
		CreateNewPosition: "Dodaj novu poziciju",
		Notification: "Obaveštenje",
		Notifications: "Obaveštenja",
		NotificationList: "Lista obaveštenja",
		NewNotification: "Dodaj obaveštenje",
		CreateNewNotification: "Dodaj novo obaveštenje",
		InvoicesPayments: "Pregled prometa",
		ServicesReport: "Pregled po uslugama",
		Documents: "Dokumenta",
		DocumentsSearch: "Pretraga dokumenata",
		DocumentsView: "Pregled dokumenata",
		DocumentsIndexing: "Indeksiranje",
		NewDocument: "Novi dokument",
		Settings: "Podešavanja",
		Seen: "Pregledano",
		Employee: "Zaposleni",
		EmployeesList: "Lista zaposlenih",
		NewEmployee: "Dodaj zaposlenog",
		CreateNewEmployee: "Dodaj novog zaposlenog",
		PersonalId: "JMBG",
		InsuranceId: "LBO",
		EducationLevel: "Nivo obrazovanja",
		ContractType: "Tip ugovora",
		UserId: "Povezan sa korisnikom",
		BirthDate: "Datum rođenja",
		ContractEndDate: "Datum isteka ugovora"
	}
});
